const booking_ready = (callback) => {
   if (document.readyState != "loading") callback();
   else document.addEventListener("DOMContentLoaded", callback);
};

booking_ready(() => {

   if (document.querySelector('.bookly-form')) {
      document.querySelector('.bookly-form').addEventListener('click', function (event) {
         const selectClinic = document.querySelector('.bookly-js-chain select');
         const clinicButton1 = document.getElementById('wcl-clinic-1');
         const clinicButton2 = document.getElementById('wcl-clinic-2');
         const nextButton = document.querySelector('.bookly-next-step');

         // Re-binding of event handler for button clicks
         if (event.target.id === 'wcl-clinic-1' || event.target.id === 'wcl-clinic-2') {
            // Find the parent element with class 'wcl-booking-image'
            const parent1 = clinicButton1.closest('.wcl-booking-image');
            const parent2 = clinicButton2.closest('.wcl-booking-image');

            // Remove the 'selected' class from both wrappers
            parent1.classList.remove('selected');
            parent2.classList.remove('selected');

            // Add the 'selected' class to the parent element of the clicked item
            const parent = event.target.closest('.wcl-booking-image');
            if (parent) {
               parent.classList.add('selected');
            }

            setTimeout(function () {
               if (event.target.id === 'wcl-clinic-1') {
                  selectClinic.value = "1"; // Select the option with value="1”
                  console.log('click 1');
               } else if (event.target.id === 'wcl-clinic-2') {
                  selectClinic.value = "2"; // Select the option with value="2”
                  console.log('click 2');
               }

               // A change event is triggered
               const changeEvent = new Event('change');
               selectClinic.dispatchEvent(changeEvent);
            }, 200);

            setTimeout(function () {
               // Simulate click on next button
               nextButton.click();
            }, 200);
         }
      });
   }
});

